module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "社区名称"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.dataSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "mobile", $$v)
      },
      expression: "params.mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.dataSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    on: {
      "change": _vm.dataSearch
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "待审核",
      "value": "loading"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已审核",
      "value": "open"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已拒绝",
      "value": "refuse"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addServiceLabels
    }
  }, [_vm._v("添加社区")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.communityList,
      "height": _vm.wheight - 270
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "提货地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.address))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "入住时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.created_date))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "community_id",
      "label": "社区ID",
      "min-width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "community_name",
      "label": "社区名称",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leader_name",
      "label": "团长姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leader_mobile",
      "label": "团长手机",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 'open') ? _c('span', [_vm._v("营业")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'close') ? _c('span', [_vm._v("暂停")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'loading') ? _c('span', [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'refuse') ? _c('span', [_vm._v("拒绝申请")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pass_date",
      "label": "通过时间",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "是否启用",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 'open' || scope.row.status === 'close') ? _c('span', [_c('el-switch', {
          attrs: {
            "active-value": "open",
            "inactive-value": "close"
          },
          on: {
            "change": function($event) {
              return _vm.SwitchChange(scope.row)
            }
          },
          model: {
            value: (scope.row.status),
            callback: function($$v) {
              _vm.$set(scope.row, "status", $$v)
            },
            expression: "scope.row.status"
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 'loading') ? _c('span', [_c('el-switch', {
          attrs: {
            "active-value": "open",
            "inactive-value": "close",
            "disabled": ""
          }
        })], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "140",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [(scope.row.status === 'loading') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.checkAction(scope.row)
            }
          }
        }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.pointlist(scope.$index, scope.row)
            }
          }
        }, [_vm._v("积分明细")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editCommunityAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteCommunityAction(scope.$index, scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "社区信息审核",
      "visible": _vm.checkVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.checkVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.community,
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "地理位置"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_vm._v(_vm._s(_vm.community.address))])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "demo-form-inline",
      attrs: {
        "inline": "true",
        "label": "社区经纬度"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.lng) + "-" + _vm._s(_vm.community.lat) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "社区名称"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.community_name) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "团长姓名"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.leader_name) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "团长手机"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.leader_mobile) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "团长身份证"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.leader_id_card) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "团长昵称"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.leader_nickname) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "备注说明"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.description) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "推荐人"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.referrer) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "社区人数"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.num) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "小区商圈"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.business_district) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "营业时间"
      }
    }, [_vm._v("\n         " + _vm._s(_vm.community.hour) + "\n       ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "审核状态"
      }
    }, [
      [_c('el-radio', {
        attrs: {
          "label": "open"
        },
        model: {
          value: (_vm.community.check_status),
          callback: function($$v) {
            _vm.$set(_vm.community, "check_status", $$v)
          },
          expression: "community.check_status"
        }
      }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": "refuse"
        },
        model: {
          value: (_vm.community.check_status),
          callback: function($$v) {
            _vm.$set(_vm.community, "check_status", $$v)
          },
          expression: "community.check_status"
        }
      }, [_vm._v("拒绝")])]
    ], 2), _vm._v(" "), (_vm.community.check_status == 'refuse') ? _c('el-form-item', {
      attrs: {
        "label": "营业时间"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": "请输入原因"
      },
      model: {
        value: (_vm.community.deny_reason),
        callback: function($$v) {
          _vm.$set(_vm.community, "deny_reason", $$v)
        },
        expression: "community.deny_reason"
      }
    })], 1) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.checkActionSubmit
      }
    }, [_vm._v("保存")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81ceed7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81ceed7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/list.vue
// module id = 2867
// module chunks = 0